
import TableHeader from '@/components/table_header/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import ReportTable from './components/reportTable.vue'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { MediaService } from '@/services'
import { StatusPlain } from './config/report'
import { parseTime } from '@/filters'
import { iFile } from '@/common/utils'

@Component({
    name: 'media-report',
    components: {
        ScrollTo,
        TableHeader,
        ReportTable
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private exportLoading = false
    private curMedia = ''
    private curStatus = StatusPlain.Not.key
    private reportList = []
    private dateRange: any = ''
    private startTime: any = ''
    private endTime: any = ''

    get statusList() {
        return Object.values(StatusPlain)
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    private mounted() {
        this.getList()
    }

    private async getList() {
        this.isLoading = true
        const params = {
            medium_id: +this.curMedia || undefined,
            status: +this.curStatus || undefined,
            page_index: this.pageIndex,
            page_size: this.pageSize,
            created_at_gte: this.startTime,
            created_at_lte: this.endTime
        }
        const result = await MediaService.getReportList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.reportList = result.data.list
        }
    }

    // 点击导出联系申请
    private async onExport() {
        this.$confirm('即将开始下载Excel文件', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                await this.exportContact()
            })
            .catch(err => {
                this.$message.error(err.message)
            })
    }

    private async exportContact() {
        const params = {
            created_at_gte: this.startTime,
            created_at_lte: this.endTime,
            status: this.curStatus
        }
        try {
            this.exportLoading = true
            const result = await MediaService.exportMediaReports(params)
            if (result.status === 200 && result.data) {
                
                const { file_name: fileName, file_data: fileData } = result.data
                if (!fileData) return this.$merror('暂无数据')

                const link = document.createElement('a')
                link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${fileData}`
                link.download=fileName
                link.target='_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }else {
                this.$merror('发生错误, 请稍后再试')
            }
        } finally {
            this.exportLoading = false
        }
        
    }

    private onTimeChange() {
        const [startTime, endTime] = this.dateRange
        this.startTime = parseTime(startTime, '{y}-{m}-{d}')
        this.endTime = parseTime(endTime, '{y}-{m}-{d}')
        // this.reset()
        this.getList()
    }

    private reset() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.reportList = []
    }

    private onReset() {
        this.reset()
        this.curStatus = StatusPlain.Not.key
        this.curMedia = ''
        this.dateRange = ''
        this.startTime = ''
        this.endTime = ''
        this.getList()
    }
}
